import {assign} from "lodash"

export class ReservationInfoModel {

  constructor(data) {
    assign(this, data)
  }
}